import { useLazyQuery, useQuery } from '@apollo/client';
import { gql } from 'graphql-tag';

export const GET_RESOURCE_USER_OTHER_PROJECTS_ALLOCATED_HOURS_SERIES_QUERY = gql`
  query GetResourceUserOtherProjectAllocatedHoursSeries(
    $input: ResourceUserOtherProjectAllocatedHoursSeriesInput!
  ) {
    resourceUserOtherProjectAllocatedHoursSeries(input: $input) {
      period {
        periodStart2
        periodEnd2
      }
      allocatedHours
    }
  }
`;

export const useResourceUserOtherProjectsAllocatedHoursSeries = ({
  userUri,
  dateRange,
  periodResolution,
  skip = false
}) => {
  const { data, loading } = useQuery(
    GET_RESOURCE_USER_OTHER_PROJECTS_ALLOCATED_HOURS_SERIES_QUERY,
    {
      variables: {
        input: {
          userUri,
          dateRange,
          periodResolution
        }
      },
      skip
    }
  );

  return {
    loading,
    resourceUserOtherProjectsAllocatedHoursSeries:
      data?.resourceUserOtherProjectAllocatedHoursSeries || []
  };
};

export const useLazyResourceUserOtherProjectsAllocatedHoursSeries = ({
  userUri,
  dateRange,
  periodResolution
}) => {
  const [
    getOtherProjectsAllocatedHoursSeries,
    { data, loading }
  ] = useLazyQuery(
    GET_RESOURCE_USER_OTHER_PROJECTS_ALLOCATED_HOURS_SERIES_QUERY,
    {
      variables: {
        input: {
          userUri,
          dateRange,
          periodResolution
        }
      }
    }
  );

  return {
    loading,
    otherProjectsAllocatedHours:
      data?.resourceUserOtherProjectAllocatedHoursSeries?.[0]?.allocatedHours ||
      0,
    getOtherProjectsAllocatedHoursSeries
  };
};
